import React from 'react';

interface SectionLabelProps {
  children: React.ReactNode;
  right?: React.ReactNode;
}

function SectionLabel({ children, right }: SectionLabelProps) {
  return (
    <div className="sky-section-label">
      <span>{children}</span>
      <span className="sky-section-label-line" />
      {right}
    </div>
  );
}

export default React.memo(SectionLabel);
